/* Based off Method 4 of making cards clickable:
 * https://css-tricks.com/block-links-the-search-for-a-perfect-solution/#method-4-sprinkle-javascript-on-the-second-method
 */
(() => {
  function initClickableCards() {
    const cards = document.querySelectorAll('.clickable\\:card');
    const mainLinks = document.querySelectorAll('.clickable\\:main');
    const secondaryLinks = document.querySelectorAll('.clickable\\:secondary');

    mainLinks.forEach(stopPropagation);
    secondaryLinks.forEach(stopPropagation);

    cards.forEach((card) => {
      card.addEventListener('click', (event) => {
        let noSelectedText = !window.getSelection().toString();

        if(noSelectedText) {
          card.querySelector('.clickable\\:main').click();
        }
      });
    });
  }

  function stopPropagation(ele) {
    ele.addEventListener('click', (e) => e.stopPropagation());
  }

  // Initialize on page load
  initClickableCards();

  // Re-initialize when pagination loads
  document.addEventListener('paginationLoaded', (e) => {
    initClickableCards();
  });
})();